import * as Yup from "yup";
const classDetailsValiation = Yup.object({
  sectionName: Yup.string()
    .max(32, "Maximum 32 character required")
    .required("Required*"),
  sectionNumber: Yup.string()
    .max(32, "Maximum 32 character required")
    .required("Required*"),
  /* instructorFirstName: Yup.string()
    .max(64)
    // .matches(/^[A-Za-z]*$/, "First name must be letter")
    .required("Required*"),
  instructorLastName: Yup.string()
    .max(64)
    // .matches(/^[A-Za-z]*$/, "Last name must be letter")
    .required("Required*"), */
  instructorEmails: Yup.array().default([]),
    // .test("unique", "unique", (value = []) => {
    //   const filtered = value.filter((email) => email);
    //   return filtered.length === new Set(filtered).size;
    // })
    // .min(1, "Must enter at least 1 email.")
    // .of(
    //   Yup.string()
    //     // .required("Required*")
    //     .max(64)
    //     .email("Oops, that doesn’t look like an email address*")
    //     .typeError("A number is required")
    // )
    // .test({
    //   name: "first",
    //   message: "*",
    //   test: (val) =>
    //     val.every((el, index) => {
    //       if (index === 0 && !el) return false;
    //       return true;
    //     }),
    // }),
  /*   startDate: Yup.date("dd/mm/yyyy")
    .max(new Date(), intl.formatMessage({ id: "startDate.error.max" }))
    .required(), */
  /*   endDate: Yup.date("dd/mm/yyyy")
    .max(new Date(), intl.formatMessage({ id: "endDate.error.max" }))
    .required(), */
});
export default classDetailsValiation;
